var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"1000"}},[_c('v-container',[_c('center',{staticClass:"mb-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"40"}})],1),_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.message))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }